<template>
    <div>
        <page-header>
            <template slot="title">Logs</template>
        </page-header>
        <pro-table
            :resource="resource"
            :fields="fields"
            :limit="25"
            ref="datatable"
            class="px-6 pt-2"
            @action="actionHandler"
            sort="created_at"
            direction="DESC"
            :permissions="true"
            :actions="actions"
        ></pro-table>

        <ActivityLogModal v-if="details" :change="details" @close="details = null" />
    </div>
</template>

<script>

import DataTableSetup from '../mixins/DataTableSetup';
import ActivityLogModal from '../components/modals/ActivityLogModal';

export default {
    name: "Logs",
    mixins: [ DataTableSetup ],
    components: { ActivityLogModal },
    data() {
        return {
            resource: 'logs',
            actions: {
                display: true,
                class: [],
                options: [
                    { label: 'View', method: 'showDetails', icon: 'eye',  type: 'method', tooltip: 'View', permissions: '' },
                ]
            },
            fields: [
                {
                    name: 'Date/Time',
                    column: 'created_at',
                    date: true,
                },
                {
                    name: 'Type',
                    column: 'subject_type_friendly',
                },
                {
                    name: 'Reference',
                    column: 'subject_id_friendly',
                },
                {
                    name: 'Caused By',
                    column: 'caused_by_friendly',
                },
            ],
            details: null,
        }
    },
    methods: {
        showDetails({item}) {
            console.log('show details', item);
            this.details = item
        }
    }
}
</script>
